import dayjs, { type Dayjs } from 'dayjs';

/** API cursor is the last completed day in free play; scenarios own their date contract. */
export const openDayDate = (cursor: string | null | undefined, type: string | undefined): string | null =>
  cursor ? dayjs(cursor).add(type === 'free' ? 1 : 0, 'day').format('YYYY-MM-DD') : null;

/**
 * `disabledDate` for pickers of player actions: days before the open day are computed
 * and closed (one-way history). Without a known open day nothing is disabled.
 */
export const disableBeforeOpenDay = (openDay: string | null | undefined) =>
  (d: Dayjs): boolean => !!openDay && d.isBefore(dayjs(openDay), 'day');

/** The date lies in the computed past (before the open day): the event is locked. */
export const isBeforeOpenDay = (
  date: string | Dayjs | null | undefined,
  openDay: string | null | undefined,
): boolean => {
  if (!date || !openDay) return false;
  const value = typeof date === 'string' ? date.slice(0, 10) : date.format('YYYY-MM-DD');
  return value < openDay;
};

/**
 * Open day for player EVENTS: cursor + 1 for every save type. The server treats
 * days ≤ cursor as computed for free and scenario saves alike (openDayPolicy,
 * ScenarioReplayService). Planting dates keep `openDayDate`.
 */
export const eventOpenDay = (cursor: string | null | undefined): string | null =>
  cursor ? dayjs(cursor).add(1, 'day').format('YYYY-MM-DD') : null;
